/* eslint-disable no-new */
import '../modules/common'
import documentReady from '../utilities/documentReady'
import Modal from '../modules/Modal'
import Accordion from '../modules/Accordion'

documentReady(() => {
  const modals = []
  Array.prototype.forEach.call(document.querySelectorAll('[data-toggle="modal"]'), (el, i) => {
    modals[i] = new Modal(el)
  })

  new Accordion('js-accordion-trigger')
})



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/secret/app.js